/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';
import React, { Component } from 'react';
import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatGivenDate } from '../../../../shared/services/common-functions';

const getBuildWeekData = params => formatGivenDate( ( params.data.buildWeek ), 'YYYY-MM-DD' );
const getParentFddDateData = params => formatGivenDate( ( params.data.parentFddDate ), 'YYYY-MM-DD' );
const getOrderEntryDateData = params => formatGivenDate( ( params.data.orderEntryDate ), 'YYYY-MM-DD' );
const getParentBuildWeekData = params => formatGivenDate( ( params.data.parentBuildWeek ), 'YYYY-MM-DD' );

function getRowClass ( params ) {

    if ( params.data.linkInd === 'P' ) {

        return 'selected-row-blue';

    }
    return null;

}

const colDefs = [
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: true,
        filter: true,
        width: 150,
        pinned: 'left',
        cellRenderer: params => ( <Link to={`/${params.data.unitName}/order/information?ordernum=${params.data.orderNumber}`}>{params.value}</Link> )
    },
    {
        headerName: 'Build Week',
        sortable: false,
        filter: false,
        width: 120,
        valueGetter: getBuildWeekData
    },
    {
        field: 'weekDiff',
        headerName: 'Week Diff',
        sortable: true,
        filter: true,
        width: 120,
        cellClassRules: {
            'atp-linked-order-differences-result-red-cell': 'x < 0'
        }
    },
    {
        field: 'rsInd',
        headerName: 'RS Ind',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'linkInd',
        headerName: 'Link Ind',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'parentOrder',
        headerName: 'Parent Order',
        sortable: true,
        filter: true,
        width: 150
    },
    {
        headerName: 'Parent FDD Date',
        sortable: false,
        filter: false,
        width: 160,
        valueGetter: getParentFddDateData
    },
    {
        headerName: 'Order Entry Date',
        sortable: false,
        filter: false,
        width: 160,
        valueGetter: getOrderEntryDateData
    },
    {
        field: 'refNo',
        headerName: 'Ref No',
        sortable: true,
        filter: true,
        width: 90
    },
    {
        field: 'model',
        headerName: 'Model',
        sortable: true,
        filter: true,
        width: 90
    },
    {
        field: 'baseMachine',
        headerName: 'Base Machine',
        sortable: true,
        filter: true,
        width: 145
    },
    {
        headerName: 'Parent Build Week',
        sortable: false,
        filter: false,
        width: 175,
        valueGetter: getParentBuildWeekData
    }
];

const excelStyles = [
    {
        id: 'greenBackground',
        interior: {
            color: '#b5e6b5',
            pattern: 'Solid'
        }
    },
    {
        id: 'centerText',
        alignment: {
            horizontal: 'Center'
        }
    },
    {
        id: 'redFont',
        font: {
            fontName: 'Calibri Light',
            underline: 'Single',
            italic: true,
            color: '#ff0000'
        }
    },
    {
        id: 'oddRowBackground',
        interior: {
            color: '#f7f7f7',
            pattern: 'Solid'
        }
    },
    {
        id: 'boldBorders',
        borders: {
            borderBottom: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderLeft: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderRight: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderTop: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            }
        }
    },
    {
        id: 'header',
        interior: {
            color: '#CCCCCC',
            pattern: 'Solid'
        },
        borders: {
            borderBottom: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderLeft: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderRight: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderTop: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            }
        }
    },
    {
        id: 'dateFormat',
        dataType: 'dateTime',
        numberFormat: { format: 'mm/dd/yyyy;@' }
    },
    {
        id: 'twoDecimalPlaces',
        numberFormat: { format: '#,##0.00' }
    },
    {
        id: 'textFormat',
        dataType: 'string'
    },
    {
        id: 'bigHeader',
        font: { size: 25 }
    },
    {
        id: 'regularHeader',
        font: { size: 14 }
    }
];

class LinkedOrderDifferencesTable extends Component {

    onGridReady = params => {

        this.gridApi = params.api;

    }

    exportExcel = () => {

        const colKeys = this.gridApi.getAllGridColumns();
        const message = 'Linked Order Differences';
        const title = 'Linked Order Differences';
        const generalParams = {
            fileName: title,
            sheetName: 'Linked Order Differences',
            exportMode: 'xlsx',
            columnKeys: colKeys,
            prependContent: [
                [],
                [
                    {
                        styleId: 'regularHeader',
                        data: {
                            type: 'String',
                            value: message
                        },
                        mergeAcross: 11
                    }
                ],
                []
            ]

        };

        this.gridApi.exportDataAsExcel( generalParams );

    };

    render () {

        return (
            <section className="atp-search-result-panel linked-order-differences-result-panel ">

                <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                    <AgGridReactComponent
                        reactNext={true}
                        columnDefs={colDefs}
                        rowData={this.props.results}
                        onGridReady={this.onGridReady}
                        excelStyles={excelStyles}
                        getRowClass={getRowClass}
                    />
                </div>

            </section>
        );

    }

}

LinkedOrderDifferencesTable.propTypes = {
    results: PropTypes.array.isRequired
};
export default LinkedOrderDifferencesTable;
